import React from "react";
import SavedCards from "@/components/SavedCards";
import { ShieldCheck } from "lucide-react";

export default function MyCards() {
  return (
    <div className="grid lg:grid-cols-[1fr_minmax(0,320px)] gap-8 lg:gap-12" data-testid="my-cards">
      <div className="border border-white/10 bg-[#0A0A0A] p-6 md:p-8">
        <SavedCards/>
      </div>
      <aside className="text-sm text-[#A1A1AA] space-y-4 lg:pt-2">
        <div className="flex items-start gap-3">
          <ShieldCheck size={18} className="text-[#D4AF37] shrink-0 mt-0.5"/>
          <p>Cards are stored securely by Square. We only keep the brand and last four digits — your full card number never touches our servers.</p>
        </div>
        <p>Saved cards appear at checkout and let dispatch settle any balance due after a trip without asking you again.</p>
      </aside>
    </div>
  );
}
